<template>
  <div>
    <h1 class="mb-4">{{ translate("communities.create") }}</h1>
    <HttpFormView endpoint="admin/communities" method="POST" :content="{ timezone: currentTimezone }" @success="router.push({ name: 'community.administration.details', params: { communityId: $event.id }, query: { tutorial: 'setup' } });">
      <template v-slot:form="{ content, errors, submit, loading }">
        <div class="card mb-4" style="border-radius: 1.2rem">
          <div class="card-body">
            <CommunityTypeSelectionView v-model:type="content.type" v-model:identifier-type="content.primaryPlayerIdentifierTypeKey"/>
            <InputErrorsView :errors="[...(errors.type ?? []), ...(errors.primaryPlayerIdentifierTypeKey ?? [])]"/>

            <div v-if="content.type && content.primaryPlayerIdentifierTypeKey" class="mt-3">
              <div>
                <h2 class="mb-3">{{ translate("community.create.name.choose") }}</h2>
                <InputView type="text" :title="translate('name')" :max="24" :value="content.name" @update:value="(content.subdomain ?? '') === utilities.slugify(content.name ?? '') ? content.subdomain = utilities.slugify($event) : undefined; content.name = $event" :errors="errors.name"/>
                <div class="d-flex align-items-center g-3 mt-3">
                  <InputView type="text" :title="translate('player.panel.domain')" :max="30" v-model:value="content.subdomain" :errors="errors.subdomain"/>
                  <div style="white-space: nowrap">.{{ state.frontendDomain }}</div>
                </div>
              </div>
              <div class="text-center w-100 mt-4">
                <ButtonView type="normal" color="primary" @click="submit()" :disabled="!content.type || !content.name">
                  {{ translate("create") }}
                </ButtonView>
              </div>
            </div>
          </div>
          <SpinnerView :active="loading" color="primary"/>
        </div>
      </template>
    </HttpFormView>
  </div>
</template>

<script setup>
import CommunityTypeSelectionView from "@/systems/community/views/CommunityTypeSelectionView.vue";
import {useRouter} from "vue-router";
import {ButtonView, HttpFormView, InputErrorsView, SpinnerView, InputView, utilities} from "@/niftybit";
import {state} from "@/state";

const router = useRouter();

const currentTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

</script>
